import customerUserRelationshipsController from './customerUserRelationshipsController'

export default customerUserRelationshipsController



// WEBPACK FOOTER //
// ../src/controllers/customerUserRelationshipsController/index.js